export default __webpack_public_path__ + "static/media/endofservice-icon.5423f331.svg";